export const CREATE_SECURITY_URL = '@SECURITYURL/CREATE_SECURITY_URL'
export const SET_SECURITY_URL_LIST = '@SECURITYURL/SET_SECURITY_URL_LIST'
export const REQUEST_SECURITY_URL_LIST = '@SECURITYURL/REQUEST_SECURITY_URL_LIST'
export const REQUEST_DELETE_SECURITY_URL = '@SECURITYURL/REQUEST_DELETE_SECURITY_URL'
export const SET_PAGE = '@SECURITYURL/SET_PAGE'